import { PureComponent, createRef } from 'react';
import { Image, Modal, Header, Grid, Icon } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import dummy from '../assets/dummy.png';
import './styles.scss';

export class ImageView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { src, t } = this.props;
    if (src === dummy) {
      return <Image src={src} />;
    }
    return (
      <Modal
        trigger={
          <Image
            className="profile-picture"
            fluid
            centered
            bordered
            src={src}
          />
        }
        basic
        size="small"
      >
        <Header
          content={t('formulary.organisation_logo')}
          className="image-view-header"
        />
        <Modal.Content className="image-view">
          <Image src={src} />
        </Modal.Content>
      </Modal>
    );
  }
}

export class AvFieldUpload extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      image: props.imageUrl || dummy,
      file: null,
    };
    this.fileInputRef = createRef();
  }

  getImage(event) {
    if (event.target.files[0]) {
      this.setState({
        file: event.target.files[0],
        image: URL.createObjectURL(event.target.files[0]),
      });
    } else {
      return false;
    }
  }

  getCurrentImage() {
    const { file } = this.state;
    return file;
  }

  render() {
    const { image, t } = this.props;
    return (
      <div className="org-profile-pic-segment-edit">
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <span className="org-profile-container">
              <Image src={image} size="small" />
            </span>
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={16}
            computer={8}
            className="org-profile-btn-col"
          >
            <div className="org-profile-btn">
              <label
                className="org-click-to-upload"
                onClick={() => this.fileInputRef.current.click()}
              >
                {t('formulary.click_to_upload')}
              </label>
              {!!this.state.file ? (
                <div className="org-profile-pic-name">
                  <Icon name="attach" /> {this.state.file.name}
                </div>
              ) : null}
              <label className="org-profile-des">
                {t('formulary.supports_formats')}
              </label>
            </div>
            <input
              ref={this.fileInputRef}
              type="file"
              hidden
              accept="image/gmp, image/jpg, image/jpeg, image/png"
              onChange={(e) => this.getImage(e)}
            />
          </Grid.Column>
        </Grid.Row>
      </div>
    );
  }
}

// Wrap components with withTranslation HOC
ImageView = withTranslation()(ImageView);
AvFieldUpload = withTranslation()(AvFieldUpload);
